import React, { useEffect } from 'react';
import styles from './DeleteCardDav.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  SettingsInlineButton,
  Section,
  SettingsSectionBox,
  SettingsSectionLabel,
} from '@views/Settings/components';
import { selectCardDavIntegration } from '@repo/redux/reducers/user/integrations';
import {
  deleteCardDavIntegration,
  fetchCardDavIntegration,
} from '@repo/redux/actions/integrations';

export default function DeleteCardDav() {
  const dispatch = useDispatch();
  const cardDavIntegration = useSelector(selectCardDavIntegration);

  useEffect(() => {
    if (!cardDavIntegration) {
      dispatch(fetchCardDavIntegration());
    }
  }, []);

  if (!cardDavIntegration) {
    return null;
  }

  return (
    <Section>
      <SettingsSectionLabel>Delete CardDav</SettingsSectionLabel>
      <SettingsSectionBox className={styles.container}>
        <div className={styles.title}>Delete your CardDav Integration</div>
        <SettingsInlineButton onClick={() => dispatch(deleteCardDavIntegration())}>
          Delete
        </SettingsInlineButton>
        <p>Reset your a** back to the Stone Ages</p>
      </SettingsSectionBox>
    </Section>
  );
}
